import {inject, Injectable} from '@angular/core';
import {CmsApiService} from '../../core/cms-api.service';
import {GetArtifactParams} from '../../core/definitions/get-artifact-params';
import {SuperObjectModel} from '../../core/definitions/super-object-model';
import {SearchParameters} from '../../core/definitions/search-parameters';
import {SearchService} from "../../core/search.service";
import {ObjectTypes} from "../../core/definitions/object-types";

export class Location extends SuperObjectModel {
  superobject_type_id: string;
  parent_id_value: string;
  m_path: string;
  level: number;
  is_leaf: boolean;
  valid: boolean;
}

export class MultipleParentsPlaceItem {
  parent_id: string;
  parent_id_value: string;
}

export class Place extends SuperObjectModel {
  superobject_type_id: string;
  place_parents: MultipleParentsPlaceItem[];
}

@Injectable({
  providedIn: 'root'
})
export class AdminLocationPlaceService {
  private readonly cmsApi: CmsApiService = inject(CmsApiService);
  private readonly searchService: SearchService = inject(SearchService);

  public async getLocation(locationId: string): Promise<Location> {
    return await this.cmsApi.getArtifact({
      artifact_id: locationId
    } as GetArtifactParams) as Location;
  }

  public async getDefaultLocationModel(objectType: string, parentId: string, parentIdValue: string): Promise<Location> {
    const location = await this.cmsApi.createArtifact({
      object_type: objectType
    }) as Location;
    location.parent_id = parentId;
    location.parent_id_value = parentIdValue;
    return location;
  }

  public async getDefaultPlaceModel(objectType: string, parentId: string, parentIdValue: string): Promise<Place> {
    const place = await this.cmsApi.createArtifact({
      object_type: objectType
    }) as Place;
    if (parentId) {
      const placeParent = await this.cmsApi.createArtifact({
        object_type: ObjectTypes.MULTIPLE_PARENTS_PLACE_ITEM
      }) as MultipleParentsPlaceItem;
      placeParent.parent_id = parentId;
      placeParent.parent_id_value = parentIdValue;
      place.place_parents.push(placeParent);
    }
    return place;
  }

  public async saveLocation(location: Location): Promise<Location | null> {
    const res: any = await this.cmsApi.saveArtifact({
      artifact: location
    });
    if (!res) {
      return null;
    }
    location.artifact_id = res.artifact_id;
    return location;
  }

  // eslint-disable-next-line max-len
  public async getObjectNamesWhereLocationIsUsed(locationId: string): Promise<{numObjects: number, objects: Array<{id: string, name: string}>}> {
    const res = await this.searchService.search({
      query: `permanent_placement.location_id:"${locationId}"`,
      fl: ['artifact_id', 'artifact_name'],
      sort: 'artifact_name asc'
    } as SearchParameters);
    return {
      numObjects: res.search_count,
      objects: res?.artifacts?.map(a => ({
        id: a.artifact_id,
        name: a.artifact_name
      }))
    };
  }
}
